import { render } from "./fundWalletComponent.vue?vue&type=template&id=1a94bc43"
import script from "./fundWalletComponent.vue?vue&type=script&lang=js"
export * from "./fundWalletComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__